import type { Project } from '@/api/client';
import { cn } from '../../cn';
import { Tooltip } from '../../ui/tooltip';
import { flagSpokenLabel, getProjectFlags, type FlagField, type FlagNoteField } from '../model/projectFlags';
import { FLAG_STAGE_COLOR_VAR } from './flagColors';
import { FlagTip } from './FlagTip';

/**
 * Отметки точками столбиком у правого края строки списка — УЗ, ФН, ЦП, PDF, СОГ, СД сверху вниз, в том же порядке и тех же
 * цветах, что вкладка карточки; серая — не отмечено. У каждой точки своя подсказка — имя и комментарий; зона наведения 10 px,
 * сама точка 6 px. Шесть зон — 60 px: столбик почти во всю высоту текста строки (58 px).
 */
export function ProjectFlagDots({ project, className }: { project: Pick<Project, FlagField | FlagNoteField>; className?: string }) {
  return (
    <span className={cn('nd:flex nd:shrink-0 nd:flex-col', className)}>
      {getProjectFlags(project).map((view) => (
        // Справа: над столбиком подсказка закрывала бы соседние точки
        <Tooltip key={view.field} label={<FlagTip name={view.name} note={view.note} />} side="right">
          <span role="img" aria-label={flagSpokenLabel(view)} className="nd:grid nd:size-2.5 nd:place-items-center">
            <span
              className="nd:size-1.5 nd:rounded-full nd:bg-foreground/20"
              style={view.stage === 0 ? undefined : { backgroundColor: FLAG_STAGE_COLOR_VAR[view.stage] }}
            />
          </span>
        </Tooltip>
      ))}
    </span>
  );
}
